import $ from 'jquery';

const updateDescription = function () {
    let scriptTag = document.getElementById("sas_user_info");
    if (scriptTag) {
        let auth = checkAuth(scriptTag);
        if(auth && $( "p.dcw_banner-heading_text" ).data( "cms-description" ) != null){
            $( "p" ).remove(".dcw_banner-heading_text[data-cms-description='unauth']");
        }else if($( "p.dcw_banner-heading_text" ).data( "cms-description" ) != null){
            $( "p" ).remove(".dcw_banner-heading_text[data-cms-description='auth']");
        }
    }else{
        if($( "p.dcw_banner-heading_text" ).data( "cms-description" ) != null){
            $( "p" ).remove(".dcw_banner-heading_text[data-cms-description='auth']");
        }
    }
};

function checkAuth(scriptTag) {
    try {
        let userInfos = JSON.parse(scriptTag.innerHTML.trim());
        if (userInfos && userInfos["IdStat"] != null) {
            return true;
        } else {
            console.error("Impossible de récupérer les informations utilisateur");
            return false;
        }
    } catch(e) {
        console.error("Impossible de récupérer les informations utilisateur");
        return false;
    }
}

export {updateDescription};


// WEBPACK FOOTER //
// ./src/js/cms/commons/update-description.js